import { Button } from "@mui/material";
import ChevronIcon from "assets/icons/ChevronIcon";
import { useDispatch } from "react-redux";
import { addOpenDrawer } from "../../../../store/actions/appAction";
import HashtagIcon from "assets/icons/Hashtag";

export interface HeaderProps {
  heading: string;
  id: string;
  hasInstallment?: boolean;
}

export default function Header({ heading, id, hasInstallment = false }: HeaderProps) {
  const dispatch = useDispatch();

  return (
    <div
      style={{
        padding: "12px 24px",
        borderBottom: "1px solid #DCDFE8",
        display: "flex",
        alignItems: "center",
        gap: 20,
      }}
    >
      <Button
        style={{ backgroundColor: "#EBEFF5", minWidth: 32, minHeight: 32, borderRadius: 4 }}
        onClick={() => {
          dispatch(addOpenDrawer(false, undefined, null));
        }}
      >
        <ChevronIcon rotate="right" color="#95A3B5" />
      </Button>

      {/* {hasInstallment &&  <span></span>} */}
      <span>
        {hasInstallment && "لسیت اقساط"} {heading}
      </span>
      <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
        <div
          style={{
            border: "1px solid #EBEFF5",
            color: "#7E8C9E",
            width: 18,
            height: 18,
            borderRadius: 4,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <HashtagIcon style={{transform:"scale(0.9)"}} color="#747575"/>
        </div>
        <span>{id}</span>
      </div>
    </div>
  );
}
